/**
 * Tracks whether the user has been redirected to an external link via
 * `useExternalLinks`. When they return to the tab/iframe, the iframe asks the
 * parent app to refetch loyalty data (the parent owns the network call and
 * will push fresh `badgesConfiguration` back via `UWM_REFRESH_BADGES_DATA`).
 */
let externalLinkOpened = false;

export const markExternalLinkOpened = () => {
    externalLinkOpened = true;
};

export const consumeExternalLinkOpened = (): boolean => {
    if (!externalLinkOpened) return false;
    externalLinkOpened = false;
    return true;
};
